import { useQuery } from '@tanstack/react-query';

import { DefaultResponse } from 'src/api/api.types';
import { TenantType } from 'src/types';
import { QueryOptions } from 'src/utils/libs/reactQuery';
import { tenantService } from '../tenant.service';

const useTenant = (id: number, options?: QueryOptions<DefaultResponse<TenantType>>) => {
  const { data: tenant, ...rest } = useQuery({
    queryKey: ['tenants', id],
    queryFn: () => {
      return tenantService.get(id);
    },
    ...options,
  });

  return { tenant: tenant?.payload, ...rest };
};

export default useTenant;
